import { createBrowserRouter, type RouteObject } from 'react-router-dom';

import ErrorPage from '@/components/shared/ErrorPage';
import { constants } from '@/constants';
import ContactInfo from '@/features/appointments/routes/ContactInfo';
import EmailInquiry from '@/features/appointments/routes/EmailInquiry';
import AppointmentCancelled from '@/features/confirmation/components/AppointmentCancelled';
import EmailConfirmation from '@/features/confirmation/routes/EmailConfirmation';
import HelpSelection from '@/features/helpSelection/routes/HelpSelection';
import LoadAppointment from '@/features/loadAppointment/routes/LoadAppointment';
import RelevanceSearch from '@/features/relevanceSearch/routes/RelevanceSearch';
import SelectAppointmentType from '@/features/scrollFlow/pages/AppointmentType/components/SelectAppointmentType';
import { FlowType } from '@/types/FlowType';
import Confirmation from '../confirmation/routes/Confirmation';
import ScrollFlowLayout from './components/ScrollFlowLayout';
import CalendarSelection from './pages/Calendar/components/CalendarSelection';
import RescheduleCalendarSelection from './pages/Calendar/components/RescheduleCalendarSelection';
import RescheduleAgentSelection from './pages/SelectAgent/components/RescheduleAgentSelection';
import SelectAgent from './pages/SelectAgent/components/SelectAgent';

const baseName = constants.APP_BASE_URL;

const emailFlowPaths = ['/email', '/email-inquiry', '/email-confirmation'];

export const createRoutesConfiguration = (): RouteObject[] => {
  const pathname = window.location.pathname;
  const isEmailFlow = emailFlowPaths.some((path) => pathname.startsWith(path));
  const redirectPath = isEmailFlow
    ? `${constants.APP_BASE_URL}/email`
    : baseName;
  return [
    {
      element: <ScrollFlowLayout />,
      children: [
        {
          path: '/',
          element: <HelpSelection flow={FlowType.SCHEDULE} />,
        },
        {
          path: '/search',
          element: <RelevanceSearch flow={FlowType.SCHEDULE} />,
        },
        {
          path: '/email',
          element: <RelevanceSearch flow={FlowType.EMAIL} />,
        },
        {
          path: '/schedule-appointment/:id',
          element: <SelectAppointmentType />,
        },
        {
          path: '/schedule-appointment/:id/date-selection',
          element: <CalendarSelection />,
        },
        {
          path: '/schedule-appointment/:id/agent-selection',
          element: <SelectAgent />,
        },
        {
          path: '/schedule-appointment/:id/contact-info',
          element: <ContactInfo />,
        },
        { path: '/confirmation', element: <Confirmation /> },
        {
          path: '/reschedule-appointment/:id/date-selection',
          element: <RescheduleCalendarSelection />,
        },
        {
          path: '/reschedule-appointment/:id/agent-selection',
          element: <RescheduleAgentSelection />,
        },
        {
          path: '/cancel-appointment/:id',
          element: <AppointmentCancelled />,
        },
        { path: '/load-appointment', element: <LoadAppointment /> },
        {
          path: '/email-inquiry/:id/contact-info',
          element: <EmailInquiry />,
        },
        {
          path: '/email-confirmation',
          element: <EmailConfirmation />,
        },
      ],
    },
    {
      path: '/*',
      element: (
        <ErrorPage
          onClickTryAgain={() => {
            window.location.replace(redirectPath);
          }}
        />
      ),
    },
  ];
};

export const createRouter = () => {
  const routesConfiguration = createRoutesConfiguration();
  return createBrowserRouter(routesConfiguration, {
    basename: constants.APP_BASE_URL,
  });
};
